import { createRouter, createWebHistory } from 'vue-router';
import instance from '@/http';
import { showLoader, hideLoader } from '@/utils/loadingstate';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'home' }
      // component: HomeView,
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/pages/HomePage.vue'),
      meta: { layout: 'home' },
      beforeEnter: async (_to, _from, next) => {
        try {
          const response = await instance.get('/auth/ping');
          if (response && response.status === 200) next();
        } catch (error: any) {
          console.log(error);
          if (error.response && error.response.status === 401) next('/auth/login');
        }
      }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue')
    },
    {
      path: '/auth',
      name: 'auth',
      redirect: { name: 'authLogin' },
      children: [
        {
          path: '/auth/login',
          name: 'authLogin',
          meta: { layout: 'auth', transition: 'authfade' },
          component: () => import('@/pages/auth/LoginPage.vue'),
          beforeEnter: async (_to, _from, next) => {
            try {
              const response = await instance.get('/auth/ping');
              if (response.status && response.status === 200) next('/home');
            } catch (error: any) {
              if (error && error.response) console.error(error.response.status);
              next();
            }
          }
        },
        {
          path: '/auth/reset-password',
          name: 'authResetPassword',
          meta: { layout: 'auth', transition: 'authfade' },
          component: () => import('@/pages/auth/ResetPassword.vue'),
          beforeEnter: async (_to, _from, next) => {
            try {
              const response = await instance.get('/auth/ping');
              if (response.status && response.status === 200) next('/home');
            } catch (error: any) {
              if (error && error.response) console.error(error.response.status);
              next();
            }
          }
        }
      ]
    },
    {
      path: '/admin',
      name: 'adminRoot',
      redirect: { name: 'adminHome' },
      children: [
        {
          path: '/admin/home',
          name: 'adminHome',
          meta: { layout: 'admin', transition: 'authfade' },
          component: () => import('@/pages/admin/HomePage.vue')
        },
        {
          path: '/admin/users',
          name: 'userList',
          meta: { layout: 'admin', transition: 'authfade' },
          component: () => import('@/pages/admin/usermanagement/UserList.vue')
        },
        {
          path: '/admin/applications',
          name: 'applicationList',
          meta: { layout: 'admin', transition: 'authfade' },
          component: () => import('@/pages/admin/ApplicationList.vue')
        },
        {
          path: '/admin/announcement',
          name: 'announcement',
          meta: { layout: 'admin', transition: 'authfade' },
          component: () => import('@/pages/admin/ApplicationList.vue')
        },
        {
          path: '/admin/logs',
          name: 'adminLogs',
          meta: { layout: 'admin', transition: 'authfade' },
          component: () => import('@/pages/admin/LogViewer.vue')
        },
        {
          path: '/admin/settings',
          name: 'adminSettings',
          meta: { layout: 'admin', transition: 'authfade' },
          component: () => import('@/pages/admin/ApplicationList.vue')
        },
      ]
    },

    {
      path: '/error',
      name: 'error',
      redirect: { name: 'errorInternal' },
      children: [
        {
          path: '/error/500',
          name: 'errorInternal',
          meta: { layout: 'error' },
          component: () => import('@/pages/error/ErrorInternal.vue')
        },
        {
          path: '/error/network',
          name: 'errorNetwork',
          meta: { layout: 'error' },
          component: () => import('@/pages/error/ErrorNetwork.vue')
        }
      ]
    },

    /* Not found page route */
    {
      path: '/:pathMatch(.*)*',
      component: () => import('@/pages/error/ErrorNotFound.vue'),
      meta: { layout: 'error', mustAdmin: false }
    }
  ]
});

router.onError((error) => {
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    // window.location.reload
    console.error('Failed to load component(s)');
  }
});

router.beforeEach((to, from, next) => {
  showLoader(); // Show loader
  next();
});

router.afterEach(() => {
  hideLoader(); // Hide loader
});

export default router;
